import { Injectable } from '@angular/core';
import { AuthStatePersistenceService, EventService } from '@spartacus/core';
import { Ga4GgCategoryListingFacetSelectEvent } from '../../events/analytics/ga4/listing/ga4-gg-category-listing-facet-select.event';
@Injectable({
  providedIn: 'root',
})
export class FacetComponentService {
  constructor(
    private eventService: EventService,
    private authStatePersistenceService: AuthStatePersistenceService
  ) {}

  dispatchGa4GgCategoryListingFacetSelectEvent(clickText: string, categoryName: string) {
    this.eventService.dispatch<Ga4GgCategoryListingFacetSelectEvent>(
      {
        event: 'product_filter',
        click_text: clickText,
        name: categoryName,
        visitor_type: this.authStatePersistenceService.isUserLoggedIn() ? 'logged_in' : 'logged-out',
      },
      Ga4GgCategoryListingFacetSelectEvent
    );
  }
}
